import React from "react";
import profile from "../assets/profile.jpg";
import cv from "../assets/cv.pdf";
import AboutText from "../components/AboutText";
import ProgressBox from "../components/ProgressBox";
import SkillSection from "../components/SkillSection";
import ResumeBox from "../components/ResumeBox";
import AchievementSection from "../components/AchievementSection";

function AboutPage() {
  return (
    <div className="tokyo_tm_section">
      <div
        data-aos="fade-right"
        data-aos-duration="1200"
        className="aos-init aos-animate">
        <div className="container">
          <div className="tokyo_tm_about">
            <div className="tokyo_tm_title">
              <div className="title_flex">
                <div className="left">
                  <span>About</span>
                  <h3>About Me</h3>
                </div>
              </div>
            </div>
            <div className="top_author_image">
              <img src={profile} srcSet={profile} alt="about" />
            </div>
            <div className="about_title">
              <h3>Yulius</h3>
              <span>
                Web Developer, Mobile Developer, UI/UX Designer, Backend
                Developer
              </span>
            </div>
            <AboutText />
            <div className="tokyo_tm_short_info">
              <div className="left">
                <div className="tokyo_tm_info">
                  <ul>
                    <li>
                      <span>Birthday:</span>
                      <span>06.07.2001</span>
                    </li>
                    <li>
                      <span>Age:</span>
                      <span>22</span>
                    </li>
                    <li>
                      <span>Address:</span>
                      <span>Alam Sutera, Tangerang City, Banten</span>
                    </li>
                    <li>
                      <span>Email:</span>
                      <span>
                        <a href="mailto:yiyus49@gmail.com">yiyus49@gmail.com</a>
                      </span>
                    </li>
                    <li>
                      <span>Phone:</span>
                      <span>
                        <a href="tel:+6289501784227">+6289501784227</a>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="right">
                <div className="tokyo_tm_info">
                  <ul>
                    <li>
                      <span>Nationality:</span>
                      <span>Indonesia</span>
                    </li>
                    <li>
                      <span>Study:</span>
                      <span>Satya Wacana Christian University</span>
                    </li>
                    <li>
                      <span>Degree:</span>
                      <span>Bachelor</span>
                    </li>
                    <li>
                      <span>Interest:</span>
                      <span>Learn</span>
                    </li>
                    <li>
                      <span>Freelance:</span>
                      <span>Available</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="tokyo_tm_button" data-position="left">
              <a href={cv} download="">
                <span>Download CV</span>
              </a>
            </div>
          </div>
        </div>
        <ProgressBox />
        <SkillSection />
        <ResumeBox />
        <AchievementSection />
      </div>
    </div>
  );
}

export default AboutPage;
